module.exports = {
    theme: {
        extend: {
            colors: {
                palette: {
                    blue: '#0a2768',
                    orange: '#fd771c',
                    logoorange: '#f8993f',
                    gray: '#6b7280',
                    darkgray: '#1e1e1e',
                    lightgray: '#fcfcfc',
                    backgroundgray: '#f8fafd',
                    textgray: '#8f8f8f',
                    slidergray: '#e8e8e8',
                    lightblue: '#c2ebfe',
                    flatred: '#fe5b55',
                }
            },
        },
        fontFamily: {
            barlow: ['Barlow', 'sans-serif'],
            montserrat: ['Montserrat', 'sans-serif'],
            be_vietnam_pro: ['Be Vietnam Pro', 'sans-serif'],
        },
    },

    plugins: [
        require('@tailwindcss/aspect-ratio'),
        require('@tailwindcss/typography'),
        require('@tailwindcss/line-clamp'),
        require('@tailwindcss/forms'),
    ],

    content: [
        __dirname + '/galaxy/modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/app/Modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/resources/**/*.{vue,js,scss,php}',
    ],
};
